// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"7002":"efcb1cae","7554":"a509e04b","9086":"07a3390a"}[chunkId] + ".css";
};